import React from 'react'
import PropTypes from 'prop-types'
import {
  EMPTY,
  formatDateTime,
  isSecretKey,
  safeStringify
} from '../Shared/detailFormat'
import { mergeFieldHistory } from './memberFields'

const describeHistoryValue = (field, value) => {
  if (value === undefined || value === null) {
    return EMPTY
  }
  if (isSecretKey(field)) {
    return 'set (hidden)'
  }
  return typeof value === 'string' ? value : safeStringify(value)
}

// Recorded profile changes across the member's classes, newest first.
const FieldHistoryComponent = ({ sources }) => {
  const rows = mergeFieldHistory(sources)
  if (rows.length === 0) {
    return <p className="text-muted mb-0">No recorded changes</p>
  }
  return (
    <div className="detail-table-scroll">
      <table className="table table-sm mb-0">
        <thead className="sticky-header">
          <tr>
            <th>When</th>
            <th>Field</th>
            <th>From</th>
            <th>To</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.key}>
              <td className="text-nowrap">{formatDateTime(row.timestamp)}</td>
              <td>
                <code>{row.field}</code>{' '}
                <small className="text-muted">{row.className}</small>
              </td>
              <td className="text-muted small">{describeHistoryValue(row.field, row.oldValue)}</td>
              <td className="small">{describeHistoryValue(row.field, row.newValue)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

FieldHistoryComponent.propTypes = {
  sources: PropTypes.arrayOf(PropTypes.shape({
    className: PropTypes.string.isRequired,
    object: PropTypes.object
  })).isRequired
}

export default FieldHistoryComponent
